import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { type ApplicationConfig, inject, isDevMode, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { nexpoEventScopeInterceptor, provideNexpoApi, provideNexpoEventScope } from '@soft2code/nexpo-lib/api';
import { nexpoAuthInterceptor, provideNexpoAuth } from '@soft2code/nexpo-lib/core';
import { provideNexpoI18n } from '@soft2code/nexpo-lib/i18n';
import { provideNexpoMockData } from '@soft2code/nexpo-lib/mock';
import { provideNexpoTheme } from '@soft2code/nexpo-lib/theme';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { VISITOR_DEMO_MODE } from './core/demo/demo-mode';
import { FairContext } from './core/fair/fair-context';

export const appConfig: ApplicationConfig = {
	providers: [
		provideZonelessChangeDetection(),
		provideRouter(
			routes,
			withComponentInputBinding(),
			withViewTransitions({ skipInitialTransition: true }),
			withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })
		),
		provideHttpClient(withFetch(), withInterceptors([nexpoAuthInterceptor, nexpoEventScopeInterceptor])),

		provideNexpoApi({ baseUrl: environment.apiUrl, application: 'NEXPO-CLIENT' }),
		// A feira vem do endereço, carregada pelo fairGuard antes de qualquer tela dela.
		provideNexpoEventScope(() => inject(FairContext).eventId()),

		// Entrar é opcional: o visitante usa a feira inteira sem conta, e entrar só
		// devolve a pessoa ao que ela estava fazendo.
		provideNexpoAuth({ loginPath: '/entrar', homePath: '/' }),

		// Abre em escuro — usado sob sol forte e à noite — e com a cor da feira no acento.
		provideNexpoTheme({ defaultPreference: 'dark', storageKey: 'nexpo_visitante_theme', accent: 'fair' }),
		provideNexpoI18n({ storageKey: 'nexpo_visitante_language' }),

		// Sem leitura pública na API (NEXPO-API-09), os dados da feira vêm do adaptador
		// em memória onde o ambiente permite, e cada tela leva a tarja de demonstração.
		...(environment.useMockData ? [provideNexpoMockData({ latencyMs: 260, anchorToday: true })] : []),
		{ provide: VISITOR_DEMO_MODE, useValue: environment.useMockData },

		provideServiceWorker('ngsw-worker.js', {
			enabled: !isDevMode(),
			registrationStrategy: 'registerWhenStable:30000',
		}),
	],
};
